import React from 'react';
import { motion } from 'framer-motion';
import { Tag } from '../types';

interface TagBubbleProps {
    tag: Tag;
    isSelected: boolean;
    onToggle: () => void;
    index: number;
}

const TagBubble: React.FC<TagBubbleProps> = ({
    tag,
    isSelected,
    onToggle,
    index,
}) => {
    return (
        <motion.button
            type="button"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.2, delay: index * 0.02 }}
            onClick={onToggle}
            className={`
                px-4 py-2 rounded-full text-sm font-medium
                transition-all duration-200 cursor-pointer border-2
                ${
                    isSelected
                        ? 'bg-purple-600 text-white shadow-lg border-purple-400'
                        : 'bg-white/10 text-white border-white/20 hover:bg-white/20'
                }
            `}
        >
            #{tag.name}
        </motion.button>
    );
};

export default TagBubble;
